interface SlideThreeProps {
  charityName: string;
  charityImpactMessage: string;
  causeBackground: string;
  customerCount?: number;
}

export const SlideThree = ({
  charityName,
  charityImpactMessage,
  causeBackground,
  customerCount
}: SlideThreeProps) => {
  const backgroundStyle = causeBackground
    ? { backgroundImage: `url(${causeBackground})` }
    : { backgroundColor: 'black' };

  let pluralEnding = charityName.endsWith('s') ? "'" : "'s";

  return (
    <div class='slide slide-three' style={backgroundStyle}>
      <div class='overlay'></div>
      <div class='header'>
        <img
          src={`https://${import.meta.env.VITE_MEDIA_HOST}/inspired-diamond.svg`}
          alt='inspired'
        />
        {charityName}{pluralEnding} Impact
      </div>
      <div class='center-content'>{charityImpactMessage}</div>
      <div class='footer'>
        {/* {customerCount ? (
          <div>
            <strong>{customerCount} customers</strong> have recently picked {charityName}
          </div>
        ) : null} */}
      </div>
    </div>
  );
};
